import i18n from 'i18next';

export const dateRangeOptions = () => {
  return {
    nextTwelveMonths: {
      id: 'nextTwelveMonths',
      label: i18n.t('nextTwelveMonths', { ns: 'reporting' }),
      displayLabel: i18n.t('nextTwelveMonthsFull', { ns: 'reporting' }),
      startDate: new Date(),
      endDate: new Date(new Date().setMonth(new Date().getMonth() + 12)),
    },
    lastTwelveMonths: {
      id: 'lastTwelveMonths',
      label: i18n.t('lastTwelveMonths', { ns: 'reporting' }),
      displayLabel: i18n.t('lastTwelveMonthsFull', { ns: 'reporting' }),
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 12)),
      endDate: new Date(),
    },
    currentVsPreviousYear: {
      id: 'currentVsPreviousYear',
      label: i18n.t('currentVsPreviousYear', { ns: 'reporting' }),
      displayLabel: i18n.t('currentVsPreviousYear', { ns: 'reporting' }),
      startDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(new Date().getFullYear(), 11, 31),
    },
    thisYear: {
      id: 'thisYear',
      label: i18n.t('thisYear', { ns: 'reporting' }),
      displayLabel: i18n.t('thisYear', { ns: 'reporting' }),
      startDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(new Date().getFullYear(), 11, 31),
    },
    previousYear: {
      id: 'previousYear',
      label: i18n.t('previousYear', { ns: 'reporting' }),
      displayLabel: i18n.t('previousYear', { ns: 'reporting' }),
      startDate: new Date(new Date().getFullYear() - 1, 0, 1),
      endDate: new Date(new Date().getFullYear() - 1, 11, 31),
    },
    custom: {
      id: 'custom',
      label: i18n.t('custom', { ns: 'reporting' }),
      displayLabel: i18n.t('custom', { ns: 'reporting' }),
      startDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(),
    },
  };
};
